import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

export type StyledSidebarProps = {
  type: 'menu' | 'settings';
  isOpen: boolean;
};

const Container = styled.div<StyledSidebarProps>`
  position: fixed;
  top: 0;
  z-index: 9999;

  height: 100%;
  min-width: 32rem;

  background-color: ${pickColor('blackLight')};

  transition: 500ms;

  ${({ type, isOpen }) =>
    type === 'menu'
      ? css`
          left: 0;
          transform: ${isOpen ? 'translateX(0)' : 'translateX(-33rem)'};
        `
      : css`
          right: 0;
          transform: ${isOpen ? 'translateX(0)' : 'translateX(33rem)'};
        `}
`;

const Inner = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;
  margin-top: 7.2rem;

  overflow-y: scroll;
`;

const Ul = styled.ul`
  width: 20rem;
`;

const Li = styled.li``;

export { Container, Inner, Ul, Li };
